declare global {
  interface Window {
    AppConfig: AppConfig;
    environment: string;
    appSubdomain: string;
    rootUrl: string;
    recaptchaSiteKey: string;
    formability_environment: string;
    CapybaraLockstep: any;
    erd: any
  }
}

export default class AppConfig {
  environment: string;
  appSubdomain: string;
  host: string = 'Formability.com';
  rootUrl: string = `https://${this.host}`;
  recaptchaSiteKey: string;

  // see toolTipManager
  currentTooltipDebounce: any

  constructor() {
    this.environment = window.environment;
    this.appSubdomain = window.appSubdomain;
    this.rootUrl = window.rootUrl;
    this.recaptchaSiteKey = window.recaptchaSiteKey;
  }

  get mode() {
    return import.meta.env.MODE;
  }

  saveTimeout() {
    switch (this.environment) {
      case 'development':
        return 1000;
      case 'production':
        return 1000;
      case 'test':
        return 100;
    }
  }

  // Simply wait the timeout then call the callback
  async onNextSaveTimeout(callback) {
    return this.delay(window.AppConfig.saveTimeout()).then(callback)
  }

  delay(t) {
    return new Promise(function(resolve) {
      setTimeout(resolve, t)
    })
  }

  queryTimeout() {
    switch (this.environment) {
      case 'development':
        return 400;
      case 'production':
        return 400;
      case 'test':
        return 0;
    }
  }

  scrollLoaderTimeout() {
    switch (this.environment) {
      case 'development':
        return 0;
      case 'production':
        return 0;
      case 'test':
        // update as necessary for test consistency
        return 200;
    }
  }

  tooltipDebounceTimeout() {
    switch(this.environment) {
      case 'development':
        return 400;
      case 'production':
        return 400;
      case 'test':
        // update as necessary for test consistency
        return 200;
    }
  }

  debounce(func, delay, context) {
    let timeout;
    return function (...args) {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  }

  /**
   * @deprecated
   * use ObjectHelper.merge instead
   * @see {ObjectHelper.merge}
   */
  mergeJson(...args): any {
    if (arguments.length === 0) {
      return {};
    }
    const first = arguments[0];
    for (let i = 1; i < arguments.length; i++) {
      const other = arguments[i];
      const propertyNames = Object.getOwnPropertyNames(other);
      for (let j = 0; j < propertyNames.length; j++) {
        const propertyName = propertyNames[j];
        if (propertyName === "__ob__") continue;
        const property = other[propertyName];
        if (Array.isArray(property)) {
          if (!first[propertyName]) {
            first[propertyName] = [];
          }
          first[propertyName] = first[propertyName].concat(property);
        } else if (property && typeof property === 'object') {
          if (!first[propertyName]) {
            first[propertyName] = {};
          }
          this.mergeJson(first[propertyName], property);
        } else {
          first[propertyName] = property;
        }
      }
    }
    return first;
  }
}
